package ui.theme

import androidx.compose.runtime.Composable
import androidx.compose.ui.text.font.FontFamily
import androidx.compose.ui.text.font.FontStyle
import androidx.compose.ui.text.font.FontWeight
import org.jetbrains.compose.resources.Font
import thewedding_cmp.composeapp.generated.resources.AlexBrush_Regular
import thewedding_cmp.composeapp.generated.resources.B612Mono_Regular
import thewedding_cmp.composeapp.generated.resources.CinzelDecorative_Black
import thewedding_cmp.composeapp.generated.resources.CinzelDecorative_Bold
import thewedding_cmp.composeapp.generated.resources.CinzelDecorative_Regular
import thewedding_cmp.composeapp.generated.resources.NotoColorEmoji_Regular
import thewedding_cmp.composeapp.generated.resources.NotoSans_Bold
import thewedding_cmp.composeapp.generated.resources.NotoSans_Regular
import thewedding_cmp.composeapp.generated.resources.OpenSans_SemiCondensed_Bold
import thewedding_cmp.composeapp.generated.resources.OpenSans_SemiCondensed_BoldItalic
import thewedding_cmp.composeapp.generated.resources.OpenSans_SemiCondensed_ExtraBold
import thewedding_cmp.composeapp.generated.resources.OpenSans_SemiCondensed_ExtraBoldItalic
import thewedding_cmp.composeapp.generated.resources.OpenSans_SemiCondensed_Italic
import thewedding_cmp.composeapp.generated.resources.OpenSans_SemiCondensed_Light
import thewedding_cmp.composeapp.generated.resources.OpenSans_SemiCondensed_LightItalic
import thewedding_cmp.composeapp.generated.resources.OpenSans_SemiCondensed_Medium
import thewedding_cmp.composeapp.generated.resources.OpenSans_SemiCondensed_MediumItalic
import thewedding_cmp.composeapp.generated.resources.OpenSans_SemiCondensed_Regular
import thewedding_cmp.composeapp.generated.resources.OpenSans_SemiCondensed_SemiBold
import thewedding_cmp.composeapp.generated.resources.OpenSans_SemiCondensed_SemiBoldItalic
import thewedding_cmp.composeapp.generated.resources.Raleway_Bold
import thewedding_cmp.composeapp.generated.resources.Raleway_BoldItalic
import thewedding_cmp.composeapp.generated.resources.Raleway_ExtraBold
import thewedding_cmp.composeapp.generated.resources.Raleway_ExtraBoldItalic
import thewedding_cmp.composeapp.generated.resources.Raleway_Italic
import thewedding_cmp.composeapp.generated.resources.Raleway_Medium
import thewedding_cmp.composeapp.generated.resources.Raleway_MediumItalic
import thewedding_cmp.composeapp.generated.resources.Raleway_Regular
import thewedding_cmp.composeapp.generated.resources.Res
import thewedding_cmp.composeapp.generated.resources.YesevaOne_Regular

internal val Cinzel
    @Composable get() = FontFamily(
        Font(Res.font.CinzelDecorative_Regular, FontWeight.Normal, FontStyle.Normal),
        Font(Res.font.CinzelDecorative_Bold, FontWeight.Bold, FontStyle.Normal),
        Font(Res.font.CinzelDecorative_Black, FontWeight.Black, FontStyle.Normal)
    )


internal val Raleway
    @Composable get() = FontFamily(
        Font(Res.font.Raleway_Regular, FontWeight.Normal, FontStyle.Normal),
        Font(Res.font.Raleway_Italic, FontWeight.Normal, FontStyle.Italic),
        Font(Res.font.Raleway_Medium, FontWeight.Medium, FontStyle.Normal),
        Font(Res.font.Raleway_MediumItalic, FontWeight.Medium, FontStyle.Italic),
        Font(Res.font.Raleway_ExtraBold, FontWeight.ExtraBold, FontStyle.Normal),
        Font(Res.font.Raleway_ExtraBoldItalic, FontWeight.ExtraBold, FontStyle.Italic),
        Font(Res.font.Raleway_Bold, FontWeight.Bold, FontStyle.Normal),
        Font(Res.font.Raleway_BoldItalic, FontWeight.Bold, FontStyle.Italic)
    )

internal val B612Mono
    @Composable get() = FontFamily(
        Font(Res.font.B612Mono_Regular, FontWeight.Normal, FontStyle.Normal)
    )


internal val Domine
    @Composable get() = FontFamily(
        Font(Res.font.OpenSans_SemiCondensed_Regular, FontWeight.Normal, FontStyle.Normal),
        Font(Res.font.OpenSans_SemiCondensed_Bold, FontWeight.Bold, FontStyle.Normal),
        Font(Res.font.OpenSans_SemiCondensed_SemiBold, FontWeight.SemiBold, FontStyle.Normal),
        Font(Res.font.OpenSans_SemiCondensed_Medium, FontWeight.Medium, FontStyle.Normal),
        Font(Res.font.OpenSans_SemiCondensed_ExtraBold, FontWeight.ExtraBold, FontStyle.Normal),
        Font(Res.font.OpenSans_SemiCondensed_Light, FontWeight.Light, FontStyle.Normal),
        Font(Res.font.OpenSans_SemiCondensed_Italic, FontWeight.Normal, FontStyle.Italic),
        Font(Res.font.OpenSans_SemiCondensed_BoldItalic, FontWeight.Bold, FontStyle.Italic),
        Font(Res.font.OpenSans_SemiCondensed_SemiBoldItalic, FontWeight.SemiBold, FontStyle.Italic),
        Font(Res.font.OpenSans_SemiCondensed_MediumItalic, FontWeight.Medium, FontStyle.Italic),
        Font(
            Res.font.OpenSans_SemiCondensed_ExtraBoldItalic,
            FontWeight.ExtraBold,
            FontStyle.Italic
        ),
        Font(Res.font.OpenSans_SemiCondensed_LightItalic, FontWeight.Light, FontStyle.Italic),
        Font(Res.font.NotoColorEmoji_Regular, FontWeight.Normal, FontStyle.Normal)
    )


internal val YesevaOne
    @Composable get() = FontFamily(
        Font(Res.font.YesevaOne_Regular, FontWeight.Normal, FontStyle.Normal)
    )

internal val NotoSans
    @Composable get() = FontFamily(
        Font(Res.font.NotoSans_Regular, FontWeight.Normal, FontStyle.Normal),
        Font(Res.font.NotoSans_Bold, FontWeight.Bold, FontStyle.Normal)
    )

internal val AlexBrush
    @Composable get() = FontFamily(
        Font(Res.font.AlexBrush_Regular, FontWeight.Normal, FontStyle.Normal)
    )

internal val EmojiFont
    @Composable get() = FontFamily(
        Font(Res.font.NotoColorEmoji_Regular, FontWeight.Normal, FontStyle.Normal),
        Font(Res.font.NotoSans_Regular, FontWeight.Normal, FontStyle.Normal),
        Font(Res.font.NotoSans_Bold, FontWeight.Bold, FontStyle.Normal)
    )